<h2 mat-dialog-title>
    Réinitialisation du mot de passe
</h2>

<form [formGroup]="form">

    <mat-dialog-content>

        <div class="identifier-block">
            <div class="identifier-label">
                Utilisateur
            </div>

            <div class="identifier-value">
                {{ data.identifier }}
            </div>
        </div>

        <div class="password-rules">

            <div class="rules-title">
                Le mot de passe doit contenir :
            </div>

            <ul>
                <li>Au moins 12 caractères</li>
                <li>Une lettre majuscule</li>
                <li>Une lettre minuscule</li>
                <li>Un chiffre</li>
                <li>Un caractère spécial</li>
            </ul>

        </div>
<div 
[ngClass]="{
    'password-fields': form.invalid
  }">

        <mat-form-field
                appearance="outline"
                class="full-width">

            <mat-label>Nouveau mot de passe</mat-label>

            <input
                    matInput
                    [type]="hidePassword ? 'password' : 'text'"
                    formControlName="password">

            <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="hidePassword = !hidePassword">

                <mat-icon>
                    {{ hidePassword ? 'visibility_off' : 'visibility' }}
                </mat-icon>

            </button>

            <mat-error 
                    *ngIf="form.get('password')?.hasError('required')">

                Le mot de passe est obligatoire

            </mat-error>

            <mat-error
            class ="errorMessage"
                    *ngIf="form.get('password')?.hasError('pattern')">

                Le mot de passe doit contenir au moins 12 caractères,
                une majuscule, une minuscule, un chiffre
                et un caractère spécial.

            </mat-error>

        </mat-form-field>

        <mat-form-field
                appearance="outline"
                class="full-width">

            <mat-label>Confirmation du mot de passe</mat-label>

            <input
                    matInput
                    [type]="hideConfirmation ? 'password' : 'text'"
                    formControlName="confirmation">

            <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="hideConfirmation = !hideConfirmation">

                <mat-icon>
                    {{ hideConfirmation ? 'visibility_off' : 'visibility' }}
                </mat-icon>

            </button>

            <mat-error
                    *ngIf="form.get('confirmation')?.hasError('required')">

                La confirmation est obligatoire

            </mat-error>

        </mat-form-field>
        </div>

        <div
                class="error-box"
                *ngIf="
                    form.get('confirmation')?.value &&
                    form.value.password !== form.value.confirmation
                ">

            Les mots de passe saisis sont différents.

        </div>

        <div
                class="error-box"
                *ngIf="errorMessage">

            {{ errorMessage }}

        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">

        <button
                mat-button
                type="button"
                (click)="cancel()">

            Annuler

        </button>

        <button
                mat-flat-button
                color="primary"
                type="button"
                [disabled]="!validate()"
                (click)="submit()">

            Réinitialiser

        </button>

    </mat-dialog-actions>

</form>